import React, { useContext } from "react";
import { ButtonRenderProps, ContentSection } from "sprint-common-web";

import { DeliveryEndpointsDataContext } from "../../../../common/data/lookup-data-providers/DeliveryEndpointsDataProvider";
import { SystemPlatformDetailsContext } from "../context/SystemPlatformDetailsContext";
import { DeliveryInfo } from "./DeliveryInfo";
import { EditDeliveryInfoButton } from "./edit/EditDeliveryInfoButton";

export const DeliveryInfoSection: React.VFC = () => {
    const { isLoading } = useContext(SystemPlatformDetailsContext);
    const { isLoading: isLookupLoading } = useContext(DeliveryEndpointsDataContext);

    const editDeliveryInfoButton: ButtonRenderProps = {
        render: EditDeliveryInfoButton
    };

    return (
        <ContentSection
            header="Delivery Info"
            buttons={[editDeliveryInfoButton]}
            isLoading={isLoading || isLookupLoading}
        >
            <DeliveryInfo />
        </ContentSection>
    );
};
